var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8438 9.875C10.6562 10.0625 10.3125 10.0625 10.125 9.875L6 5.71875L1.84375 9.875C1.65625 10.0625 1.3125 10.0625 1.125 9.875C0.9375 9.6875 0.9375 9.34375 1.125 9.15625L5.28125 5L1.125 0.875C0.9375 0.6875 0.9375 0.34375 1.125 0.15625C1.3125 -0.03125 1.65625 -0.03125 1.84375 0.15625L6 4.3125L10.125 0.15625C10.3125 -0.03125 10.6562 -0.03125 10.8438 0.15625C11.0312 0.34375 11.0312 0.6875 10.8438 0.875L6.6875 5L10.8438 9.15625C11.0312 9.34375 11.0312 9.6875 10.8438 9.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.0f303f0de77add989da5aca481dda8ec.svg";
export { ForwardRef as ReactComponent };